import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Input } from '@design-system/components/input/input';
import { Typography } from '@design-system/components/typography/typography';
import { hintItem, wrapper, hintsContainer } from './titleInputWithHints.css';
import { isEmpty } from 'lodash';
import { ExerciseSuggestion } from '@client/new/pages/creator/library/models/exercise-suggestions.model';

type Hint = { title: string; description?: string; uuid: string };

type TitleInputWithHintsProps = {
  required?: boolean;
  value?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  error?: string;
  exerciseSuggestions: ExerciseSuggestion[];
  onUpdate: (description: string, uuid: string) => void;
};

export const TitleInputWithHints = ({
  required,
  value,
  onChange,
  onBlur = () => null,
  disabled,
  error,
  exerciseSuggestions = [],
  onUpdate,
}: TitleInputWithHintsProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [inputFocus, setInputFocus] = useState(false);

  const handleClick = ({ title, description, uuid }: Hint) => {
    onChange(title);
    if (description !== undefined) {
      onUpdate(description, uuid);
    }
    setInputFocus(false);
    onBlur();
  };

  const handleOutsideClick = (e: any) => {
    if (wrapperRef?.current && !wrapperRef.current.contains(e.target)) {
      setInputFocus(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick, true);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [wrapperRef]);

  const onInputChange = (ev: ChangeEvent<HTMLInputElement>) => {
    onChange(ev.target.value);
    onUpdate(null, null);
  };

  return (
    <div className={wrapper} ref={wrapperRef}>
      <Input
        label="Title"
        required={required}
        value={value}
        onChange={onInputChange}
        disabled={disabled}
        error={error}
        autoComplete="off"
        onFocus={() => setInputFocus(true)}
      />
      {inputFocus && !isEmpty(exerciseSuggestions) ? (
        <div className={hintsContainer}>
          {exerciseSuggestions.map((option) => (
            <div key={option.id} className={hintItem}>
              <Typography
                onClick={() =>
                  handleClick({
                    uuid: option.id,
                    title: option.name,
                    description: option.description,
                  })
                }
              >
                {option.name}
              </Typography>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
